import { render, staticRenderFns } from "./index.vue?vue&type=template&id=095112ca&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=095112ca&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&lang=css&"
import style2 from "./index.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095112ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('095112ca')) {
      api.createRecord('095112ca', component.options)
    } else {
      api.reload('095112ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=095112ca&scoped=true&", function () {
      api.rerender('095112ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Notification/index.vue"
export default component.exports